import { Component, ElementRef, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { IDoctor } from 'src/app/interfaces/record.interface';
import { ConfigService } from 'src/app/services/application/config.service.';

@Component({
    selector: 'app-doc-info-modal',
    templateUrl: './doc-info-modal.component.html',
    styleUrls: ['./doc-info-modal.component.scss'],
})
export class DocInfoModalComponent {
    doc!: IDoctor;
    spec!: string;

    constructor(
        private config: ConfigService,
        private activeModal: NgbActiveModal
    ) {}

    @ViewChild('modalBody')
    modalBody!: ElementRef;
    @ViewChild('header')
    header!: ElementRef;

    ngAfterViewInit() {
        if (this.modalBody && this.modalBody.nativeElement) {
            this.modalBody.nativeElement.addEventListener(
                'scroll',
                this.handleScroll.bind(this)
            );
        }
    }

    ngOnDestroy() {
        if (this.modalBody && this.modalBody.nativeElement) {
            this.modalBody.nativeElement.removeEventListener(
                'scroll',
                this.handleScroll
            );
        }
    }

    handleScroll() {
        if (this.modalBody && this.header) {
            const scrollTop = this.modalBody.nativeElement.scrollTop;

            if (scrollTop > 0) {
                this.header.nativeElement.classList.add('scrolled');
            } else {
                this.header.nativeElement.classList.remove('scrolled');
            }
        }
    }

    getDocImg(id: number) {
        return `${this.config.getValue('hostBackend')}/img/doc/${id}.png`;
    }

    getDocImgDefault(event: Event) {
        const elem = event.target as HTMLImageElement;
        elem.src = `${this.config.getValue('hostBackend')}/img/doc/not.png`;
    }

    closeModal(e: Event) {
        e.stopPropagation();
        this.activeModal.close();
    }
}
